import React, {Fragment} from 'react';
import {
    AutoComplete,
    Button,
    Checkbox,
    Collapse,
    DatePicker, Divider,
    Form,
    Input,
    InputNumber,
    Modal,
    notification,
    Select, Switch,
    Typography
} from "antd";

import ApiService from "../../../services/ApiService"
import IntlMessage from "../../../components/util-components/IntlMessage";

import {EsriProvider} from 'leaflet-geosearch';
import moment from "moment";
import RestrictedHidden from "../../../components/permissions/RestrictedHidden";
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import {getCountry} from "../../../components/permissions/functions";
import DdnHeField from "../../editors/WebEditor/components/DdnHeField";
import ContactIcon from "../../../components/util-components/ContactIcon";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import { PlusOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';

const provider = new EsriProvider();
const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalEdit extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        id: null,
        edit: false,
        child: false,
        defaultData: {},
        categories: [],
        selectedCategories: [],
        adresseOptions: [],

        fields: [],
        fieldsValues: [],

        selectOrCreate: false,
        selectOrCreateCallback:null,
        contacts:[],
        selectedContact:null,
    };

    state = this.initialState

    async show(data = null, child = false) {
        await Promise.all([this.init(), this.initFields()])

        if (data) {
            var newData = {...data}

            if (Array.isArray(newData.fields)) {
                for (var field of newData.fields) {
                    var value = field.value
                    if (["DATE", "DATETIME"].includes(field.type)) {
                        value = moment(value)
                    }
                    newData[this.formatFieldFormName(field.key, field.type)] = value
                }
            }

            this.setState({
                visible: true,
                id: newData.id,
                defaultData: newData,
                edit: true,
                selectedCategories: newData.categories,
                child: child
            })
        } else {
            this.setState({visible: true, child: child,defaultData:{pays:COUNTRY.find(i=>i.abbreviation===getCountry())?.country}})
        }
    }

    async getContacts() {
        var res = await ApiService.get("/contact/form?withAdresse=1")
        this.setState({contacts: res.data})
    }

    async selectOrCreate(callback=null) {
        await Promise.all([this.init(), this.initFields(),this.getContacts()])
        this.setState({
            visible: true,
            selectOrCreate:true,
            selectOrCreateCallback:callback,
            defaultData:{pays:COUNTRY.find(i=>i.abbreviation===getCountry())?.country}
        })
    }

    onSearch = (text) => {
        this.setState({text});
    }

    close() {
        this.setState(this.initialState)
    }


    async init() {
        var res = await ApiService.get("/contact/categories")

        if (res.success) {
            this.setState({categories: res.items})
        }
    }

    async initFields() {
        var res = await ApiService.get("/contact/fields")
        if (res.success) {
            this.setState({fields: res.items, fieldsValues: res.values})
        }
    }

    async onSelect()
    {
        if(!this.state.selectedContact){
            return false
        }

        const data=this.state.contacts.find(i=>i.id===this.state.selectedContact)

        this.close()
        if(this.state.selectOrCreateCallback){
            this.state.selectOrCreateCallback(data)
        }
    }

    async onSubmit(data) {

        if (!this.state.edit) {
            data.categories = this.state.selectedCategories
        }

        if(!data.ddn){
            data.ddn = null
        }

        for (var k of Object.keys(data)) {
            if (k.startsWith("FIELD_")) {
                var d = k.split("_")
                if (["DATE", "DATETIME"].includes(d[2]) && data[k]) {
                    data[k] = data[k].toDate()
                }

                if (data[k] === undefined || data[k] === null) {
                    delete data[k]
                }
            }
        }

        if (this.state.edit && !this.state.id) {
            notification.error({
                message: t`Erreur lors de l'édition`
            })
            this.close()
            return false
        }

        if (this.state.edit) {
            data.id = this.state.id
        }

        var res = await ApiService.post("/contact/edit", data)

        if (res.success) {
            if (res.message) {
                notification.info({
                    message: res.message
                })
            } else {
                notification.success({
                    message: this.state.edit ? t`Édition réussie` : t`Ajout réussi`
                })
            }

            const isNew= !this.state.edit
            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(res.data,isNew)
            }
            if(this.state.selectOrCreateCallback){
                this.state.selectOrCreateCallback(res.data)
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de l'édition` : t`Erreur lors de l'ajout`
            })
        }
    }


    formatFieldType(type) {
        switch (type) {
            case "TEXT":
                return t`Texte`
            case "NUMBER":
                return t`Nombre`
            case "BOOL":
                return t`Oui/Non`
            case "DATE":
                return t`Date`
            case "DATETIME":
                return t`Date & Heure`
        }

        return null
    }

    formatFieldFormName(key, type) {
        return "FIELD_" + key + "_" + type
    }

    render() {

        let title=(this.state.edit ? t`Éditer` : t`Ajouter`) + " " + t`un contact`
        if(this.state.selectOrCreate){
            title=t`Choisir un contact`
        }

        return (
            <Modal width="100%" title={title}
                   open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>

                {this.state.selectOrCreate &&(
                    <div style={{display:"flex",flexDirection:"column",justifyContent:"center"}}>

                        <Divider><Trans>Choisir un Contact</Trans></Divider>

                        <Select value={this.state.contact?.id} style={{minWidth: isMobile?"100%":400}}
                                placeholder={t`Choisir un Contact`} showSearch
                                filterOption={(input, option) => {
                                    var text = option.props.children
                                    if (Array.isArray(text)) {
                                        text = text.join("")
                                    }
                                    return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}
                                onChange={(id) => {
                                    this.setState({selectedContact:id})
                                }}
                        >
                            {this.state.contacts.map((item, index) => {
                                var telValue = ""
                                if (item.tel) {
                                    telValue = "(" + item.tel + ")"
                                }

                                var emailValue = ""
                                if (item.email) {
                                    emailValue = "(" + item.email + ")"
                                }

                                let adresses=[]
                                if(Array.isArray(item.adresses)){
                                    adresses=item.adresses.filter(i=>!i.nom?.startsWith("Adresse")).map(i=>"["+i.nom+"]")
                                }

                                return <Select.Option key={index} value={item.id}><ContactIcon
                                    contact={item}/> {item.prenom} {item.nom} {telValue} {emailValue} {adresses.join(" ")}
                                </Select.Option>
                            })}
                        </Select>

                        <div style={{display: "flex", justifyContent: "flex-end",marginTop:50,marginBottom:20}}>
                            <Button type="primary" onClick={()=>this.onSelect()}>
                                <Trans>Choisir ce contact</Trans>
                            </Button>
                        </div>


                        <Divider><Trans>Votre contact n'existe pas ?</Trans></Divider>

                        <div style={{display: "flex", justifyContent: "center",marginTop:15}}>
                            <Button style={{paddingRight:20}} icon={<PlusOutlined/>} type="primary" onClick={()=>this.setState({selectOrCreate:false})}>
                                <Trans>Créer un nouveau contact</Trans>
                            </Button>
                        </div>
                    </div>
                )}

                {!this.state.selectOrCreate &&(
                    <Form
                        labelCol={{span: 6}}
                        ref={(ref) => this.form = ref}
                        initialValues={this.state.defaultData}
                        onFinish={(data) => this.onSubmit(data)}
                    >

                        {!this.state.edit && (
                            <RestrictedHidden type="AUTH"
                                              condition={(i) => i.key === "Forfait" && ["CRM", "COM", "FULL"].includes(i.value)}>
                                <Form.Item
                                    label={t`Catégories`}
                                >
                                    <Select
                                        mode="tags"
                                        placeholder={t`Catégories`}
                                        value={this.state.selectedCategories}
                                        onSelect={(value) => {
                                            var newArray = [...this.state.selectedCategories]
                                            newArray.push(value)
                                            this.setState({selectedCategories: newArray})
                                        }}
                                        onDeselect={(value) => {
                                            var newArray = [...this.state.selectedCategories]
                                            newArray.splice(newArray.indexOf(value), 1)
                                            this.setState({selectedCategories: newArray})
                                        }}
                                    >
                                        {this.state.categories.filter(i => !this.state.selectedCategories.includes(i)).map((item, index) =>
                                            <Select.Option key={index} value={item}>{item}</Select.Option>)}
                                    </Select>
                                </Form.Item>
                            </RestrictedHidden>
                        )}

                        <RestrictedHidden type="AUTH"
                                          condition={(i) => i.key == "Forfait" && ["CRM", "COM", "FULL"].includes(i.value)}>
                            <Form.Item
                                label={t`Chef de Famille`}
                                name="chef"
                                valuePropName="checked"
                            >
                                <Checkbox value={true}/>
                            </Form.Item>
                        </RestrictedHidden>

                        <Form.Item label={t`Prénom`} name="prenom">
                            <Input placeholder={t`Prénom`}/>
                        </Form.Item>

                        <Form.Item label={t`Prénom Hébraique`} name="prenomHE">
                            <Input placeholder={t`Prénom Hébraique`}/>
                        </Form.Item>

                        <Form.Item label={t`Nom`} name="nom">
                            <Input placeholder={t`Nom`}/>
                        </Form.Item>

                        <Form.Item noStyle shouldUpdate>
                            {(_form) => {
                                if (_form.getFieldValue("homme") === false) {
                                    return (
                                        <Form.Item label={t`Nom de Jeune Fille`} name="nomJF">
                                            <Input placeholder={t`Nom de Jeune Fille`}/>
                                        </Form.Item>
                                    )
                                }
                                return null
                            }}
                        </Form.Item>

                        <Form.Item label={t`Homme / Femme`} name="homme">
                            <Select placeholder={t`Choisir`}>
                                <Select.Option value={null}><Trans>NC</Trans></Select.Option>
                                <Select.Option value={true}><Trans>Homme</Trans></Select.Option>
                                <Select.Option value={false}><Trans>Femme</Trans></Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item label={t`Date de Naissance`} name="ddn">
                            <DdnHeField/>
                        </Form.Item>

                        {!this.state.child && (
                            <Fragment>
                                <Form.Item label={t`Téléphone`} name="tel">
                                    <Input type="tel" placeholder={t`Téléphone`}/>
                                </Form.Item>

                                <Form.Item label={t`Email`} name="email">
                                    <Input type="email" placeholder={t`Email`}/>
                                </Form.Item>
                            </Fragment>
                        )}

                        <Form.Item label={t`Description`} name="description">
                            <Input.TextArea/>
                        </Form.Item>

                        <Form.Item label={t`Ce contact est décédé`} name="deceased" valuePropName={"checked"}>
                            <Switch/>
                        </Form.Item>

                        <Form.Item noStyle shouldUpdate>
                            {_form=>{
                                if(!_form.getFieldValue('deceased')){
                                    return null
                                }

                                return(
                                    <Fragment>
                                        <Form.Item label={t`Date du décès`} name="deceasedDate">
                                            <DdnHeField/>
                                        </Form.Item>

                                        <Form.Item label={t`Prénom Hébraique du Père`} name="deceasedPere">
                                            <Input placeholder={t`Prénom Hébraique du Père`}/>
                                        </Form.Item>

                                        <Form.Item label={t`Prénom Hébraique de la Mère`} name="deceasedMere">
                                            <Input placeholder={t`Prénom Hébraique de la Mère`}/>
                                        </Form.Item>

                                        <Form.Item label={t`Lieu de l'enterrement`} name="deceasedLocation">
                                            <Input placeholder={t`Lieu de l'enterrement`}/>
                                        </Form.Item>
                                    </Fragment>
                                )
                            }}
                        </Form.Item>

                        {!this.state.child && (
                            <Collapse forceRender style={{marginBottom: 20}}>
                                <Collapse.Panel forceRender header={t`Adresse Principale`} key={0}>

                                    <Form.Item label={t`Adresse`} name="adresse">
                                        <AutoComplete
                                            options={this.state.adresseOptions.map(i => ({
                                                object: i,
                                                value: i.adresse,
                                                label: i.raw
                                            }))}
                                            placeholder={t`Adresse`}
                                            onSearch={(inputValue) => {
                                                clearTimeout(this.timeoutAdresse)
                                                this.timeoutAdresse = setTimeout(async () => {
                                                    var value = inputValue.trim()
                                                    if (value) {
                                                        var results = await provider.search({query: value})
                                                        var finalResult = results.map((item) => {
                                                            var arrayValue = item.label.split(",")
                                                            return {
                                                                raw: item.label,
                                                                adresse: arrayValue[0],
                                                                postal: arrayValue[1],
                                                                ville: arrayValue[2]
                                                            }
                                                        })
                                                        this.setState({adresseOptions: finalResult})
                                                    }
                                                }, 500)
                                            }}
                                            onSelect={(value, option) => {
                                                this.form.setFieldValue("postal", option.object.postal)
                                                this.form.setFieldValue("ville", option.object.ville)
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item label={t`Code Postal`} name="postal">
                                        <Input placeholder={t`Code Postal`}/>
                                    </Form.Item>

                                    <Form.Item label={t`Ville`} name="ville">
                                        <Input placeholder={t`Ville`}/>
                                    </Form.Item>

                                    <Form.Item label={t`Pays`} name="pays">
                                        <Select showSearch placeholder={t`Pays`}>
                                            {COUNTRY.map(i=>(
                                                <Select.Option value={i.country}>{i.country}</Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item label={t`Complément Adresse`} name="note_adresse">
                                        <Input.TextArea placeholder={t`(Optionnelle)`}/>
                                    </Form.Item>

                                </Collapse.Panel>
                            </Collapse>
                        )}

                        {this.state.fields.length > 0 && (
                            <Collapse forceRender style={{marginBottom: 20}}>
                                <Collapse.Panel forceRender header={t`Informations Supplémentaires`} key={0}>
                                    {this.state.fields.map((field, index) => {

                                        const values = this.state.fieldsValues.find(i => i.key == field.key && i.type == field.type)?.values || []

                                        return (
                                            <div key={index}>
                                                {field.type == "TEXT" && (
                                                    <Form.Item
                                                        label={`${field.key} (${this.formatFieldType(field.type)})`}
                                                        name={this.formatFieldFormName(field.key, field.type)}
                                                    >
                                                        <AutoComplete
                                                            options={values.map(v => ({
                                                                label: v,
                                                                value: v
                                                            }))}
                                                            placeholder={t`Sélectionnez ou donnez une nouvelle valeur`}
                                                        />
                                                    </Form.Item>
                                                )}

                                                {field.type == "NUMBER" && (
                                                    <Form.Item
                                                        label={`${field.key} (${this.formatFieldType(field.type)})`}
                                                        name={this.formatFieldFormName(field.key, field.type)}
                                                    >
                                                        <InputNumber decimalSeparator={','} placeholder={t`5 | 3.10 ...`}/>
                                                    </Form.Item>
                                                )}

                                                {field.type == "BOOL" && (
                                                    <Form.Item
                                                        label={`${field.key} (${this.formatFieldType(field.type)})`}
                                                        name={this.formatFieldFormName(field.key, field.type)}
                                                    >
                                                        <Select placeholder={t`Oui / Non`}>
                                                            <Select.Option value={"Oui"}><Trans>Oui</Trans></Select.Option>
                                                            <Select.Option value={"Non"}><Trans>Non</Trans></Select.Option>
                                                        </Select>
                                                    </Form.Item>
                                                )}

                                                {field.type == "DATE" && (
                                                    <Form.Item
                                                        label={`${field.key} (${this.formatFieldType(field.type)})`}
                                                        name={this.formatFieldFormName(field.key, field.type)}
                                                    >
                                                        <DatePicker format="DD/MM/YYYY"/>
                                                    </Form.Item>
                                                )}

                                                {field.type == "DATETIME" && (
                                                    <Form.Item
                                                        label={`${field.key} (${this.formatFieldType(field.type)})`}
                                                        name={this.formatFieldFormName(field.key, field.type)}
                                                    >
                                                        <DatePicker showTime format="DD/MM/YYYY HH:mm"/>
                                                    </Form.Item>
                                                )}
                                            </div>
                                        )
                                    })}
                                </Collapse.Panel>
                            </Collapse>
                        )}

                        <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                <Trans>Valider</Trans>
                            </Button>
                        </Form.Item>
                    </Form>
                )}

            </Modal>
        )
    }
}
